import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "grid-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid-x text-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "cell small-12" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://goo.gl/maps/xWk7GjXveqQ2",
        class: "body-text-xs text-purple",
        target: "_blank"
      }, " 595 Burrard St, Vancouver, BC V7X 1L3, Canada ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "cell small-12" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "body-text-xs text-purple-medium" }, "Copyright © 2024 Augmentify. All rights Reserved.")
    ])
  ])
], -1)

import { NLayoutFooter } from 'naive-ui'

export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NLayoutFooter), { bordered: "" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})